import axiosClient from "../axios";
import { ResultDataModel } from "../../utility/interface/api/result-data";
import { RegisterHostBlobInterface } from "../../utility/interface/hosts";

// get hosts list

export const getHostList = (
  page_no: number,
  page_size: number,
) => {
  const url = `public/hosts?page_no=${page_no}&page_size=${page_size}`;
  return axiosClient.get<ResultDataModel<any>>(url);
};

// register host

export const registerHost = (registerBlob: RegisterHostBlobInterface) => {
  const url = `/hosts`;
  const body = {
    ...registerBlob,
  };
  return axiosClient.post<ResultDataModel<any>>(url, body);
};

export const getHost = (host_id: string) => {
  const url = `hosts/${host_id}`;
  return axiosClient.get<ResultDataModel<any>>(url);
};

export const getHostMetrics = (host_id: string) => {
  const url = `hosts/${host_id}/metric`;
  return axiosClient.get<ResultDataModel<any>>(url);
};

// update specific host

export const updateHost = (
  host_id: string,
  updateHostBlob: RegisterHostBlobInterface,
) => {
  const url = `hosts/${host_id}`;
  const body = {
    ...updateHostBlob,
  };
  return axiosClient.put<ResultDataModel<any>>(url, body);
};

// toggle host status

export const installHost = (host_id: string) => {
  const url = `hosts/${host_id}/install`;
  return axiosClient.post<ResultDataModel<any>>(url);
};

// start host

export const startHost = (host_id: string) => {
  const url = `hosts/${host_id}/start`;
  return axiosClient.post<ResultDataModel<any>>(url);
};

// reset host

export const resetHost = (host_id: string) => {
  const url = `hosts/${host_id}/reset`;
  return axiosClient.post<ResultDataModel<any>>(url);
};

// stop host

export const stopHost = (host_id: string) => {
  const url = `hosts/${host_id}/stop`;
  return axiosClient.post<ResultDataModel<any>>(url);
};

// create host schedule

export const createHostSchedule = (
  host_id: string,
  payload: {
    action: string;
    type: string;
    execute_at?: string;
    cron_expression?: string;
    force_offline?: boolean;
  }
) => {
  const url = `hosts/${host_id}/host_schedules`;
  return axiosClient.post<ResultDataModel<any>>(url, payload);
};

// get all host schedules
export const getHostSchedules = (is_active: boolean = true) => {
  const url = `host_schedules?is_active=${is_active}`;
  return axiosClient.get<ResultDataModel<any>>(url);
};

// cancel host schedule
export const cancelHostSchedule = (host_id: string, schedule_id: string) => {
  const url = `hosts/${host_id}/host_schedules/${schedule_id}`;
  return axiosClient.delete<ResultDataModel<any>>(url);
};